import { MFECatalog } from "@sinch/mfe-loader";
import { getEnabledPlugins } from "./pluginConfig";

export const Plugins = () => {
  const enabledPlugins = getEnabledPlugins();

  const plugins = enabledPlugins.filter((pluginName) =>
    MFECatalog.mfeConfig[pluginName]?.flags?.includes("plugin")
  );

  return (
    <>
      {plugins.map((pluginName) => (
        <mfe-loader name={pluginName} key={pluginName} />
      ))}
    </>
  );
};
